<template>
  <div class="mx-4 w-auto flex justify-end font-museo-700 text-s">
    <div class="pagination rounded page-item mt-4 flex w-auto p-0 items-center">
      <div
        v-if="currentPage && currentPage !== startPage"
        class="option specialOption flex justify-center items-center cursor-pointer"
        :class="currentPage === 1 ? 'disabled' : ''"
        @click="$emit('onChangePage', currentPage - 1)"
      >
        ‹
      </div>
      <div
        v-for="(previousPage, previousPageIndex) in previousPages"
        :key="previousPageIndex"
        class="flex option justify-center items-center cursor-pointer hover:"
        @click="$emit('onChangePage', previousPage)"
      >
        {{ previousPage }}
      </div>
      <div
        v-if="currentPage"
        class="current-page option flex justify-center items-center cursor-pointer"
      >
        {{ currentPage }}
      </div>
      <div
          v-for="(nextPage, nextPageIndex) in nextPages"
          :key="nextPageIndex"
          class="flex option justify-center items-center cursor-pointer hover:"
          @click="$emit('onChangePage', nextPage)"
        >
        <span v-if="totalItems">
          {{ nextPage }}
        </span>
      </div>
      <div
        v-if="nextPage && nextPage > currentPage"
        class="option specialOption flex justify-center items-center cursor-pointer"
        @click="$emit('onChangePage', currentPage + 1)"
      >
        ›
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, toRefs } from "vue";

const props = defineProps({
  currentPage: {
    type: Number,
    default: 1
  },
  optionPerPageSelected: {
    type: Number,
    default: 10
  },
  totalItems: {
    type: Number,
    default: 1
  },
  nextPage: {
    type: Number,
    default: 1
  }
});
const { currentPage, nextPage } = toRefs(props);

const emit = defineEmits(["onChangePage"]);

const startPage = computed(() =>
  currentPage.value - 4 >= 1 ? currentPage.value - 4 : 1
);
const totalPages = computed(() => {
  return Math.ceil(props.totalItems / props.optionPerPageSelected);
});

const previousPages = computed(() => {
  let pages = [];

  for (let index = startPage.value; index < currentPage.value; index++) {
    pages.push(index);
  }
  return pages;
});
const nextPages = computed(() => {
  let pages = [];
  let countPages = 0;
  for (
    let index = props.currentPage + 1;
    index < totalPages.value && countPages < 4;
    index++
  ) {
    pages.push(index);
    countPages++;
  }
  return pages;
});
</script>

<style lang="scss" scoped>
.pagination {
  height: 30px;
  background-color: #00000040;
  color: #2effec;
}

.option {
  height: 30px;
  width: auto;
  min-width: 25px;
  padding-left: 3px;
  padding-right: 3px;
  color: #2effec;
  background-color: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(0, 0, 0, 0.75);
}
.specialOption {
  width: 30px;
  font-weight: bold;
  padding-bottom: 5px;
}
.current-page {
  height: 30px;
  width: 30px;
  border: 2px solid #2effec;
  border-radius: 100%;
  background-color: $topaz !important;
  color: black !important;
}
.disabled {
  background-color: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.25);
  border-color: rgba(0, 0, 0, 0.75);
  cursor: not-allowed;
  pointer-events: none;
}
button:active {
  @apply shadow-inner;
}
</style>
